<h1 mat-dialog-title>Login unsuccessful</h1>
<div mat-dialog-content>Please ensure you have entered the correct details.</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
